import axios from 'axios';

// In production/Docker, use relative URL for nginx proxy
// In development on port 3001, use localhost:5001
const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Production build (Docker/nginx): use same-origin proxy
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  // Dev server on port 3001 - call backend directly
  if (window.location.port === '3001') {
    return 'http://localhost:5001';
  }
  // Docker/production - use relative URL (nginx proxies to backend)
  return '';
};

const api = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'  // Required by backend CSRF protection
  }
});

// Add JWT token to requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('halisoft_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add X-Admin-Email for check-auth (cross-domain/email auth) and admin endpoints.
    const url = String(config.url || '');
    const needsEmailHeader =
      url.includes('/api/check-auth') ||
      url.includes('/api/admin') ||
      url.includes('/api/auth/check-admin') ||
      url.startsWith('/admin');
    if (needsEmailHeader) {
      const adminEmail =
        localStorage.getItem('halisoft_admin_email') ||
        localStorage.getItem('halisoft_email');
      if (adminEmail) {
        config.headers['X-Admin-Email'] = adminEmail;
      }
    }
    
    return config;
  },
  error => Promise.reject(error)
);

// Handle auth errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('halisoft_user');
      localStorage.removeItem('halisoft_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
